import { Injectable, makeStateKey,TransferState } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { PodcastApiService } from '../api/podcasts.service';
const PODCAST_KEY = makeStateKey('podcast_data');
@Injectable({ providedIn: 'root' })
export class PodcastResolver implements Resolve<any> {
  constructor(
    private apiService: PodcastApiService,
    private transferState: TransferState
  ) { }

  resolve(): Observable<any> {
    if (this.transferState.hasKey(PODCAST_KEY)) {
      this.transferState.remove(PODCAST_KEY);
    }
    return this.apiService.getPodcast(1);
  }
}